import React from "react";

// Filtres SVG que conarteixen vores rectes en vores de paper estripat irregular
export default function PaperFilters() {
  const variants = [
    { id: "paperTorn1", seed: 4, scale: 17 },
    { id: "paperTorn2", seed: 17, scale: 13 },
    { id: "paperTorn3", seed: 33, scale: 20 },
  ];
  return (
    <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
      <defs>
        {variants.map((v) => (
          <filter key={v.id} id={v.id} x="-25%" y="-25%" width="150%" height="150%">
            <feTurbulence type="fractalNoise" baseFrequency="0.013 0.016" numOctaves="4" seed={v.seed} result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale={v.scale} xChannelSelector="R" yChannelSelector="G" />
            <feDropShadow dx="0" dy="7" stdDeviation="7" floodColor="#2c4c3b" floodOpacity="0.22" />
          </filter>
        ))}
      </defs>
    </svg>
  );
}
